import React from 'react'

import { styled, Typography, Stack } from '@mui/material'
import { Directions as DirectionsIcon, LocationOn as LocationOnIcon } from '@mui/icons-material'
import { grey } from '@mui/material/colors'

import { formatTitleCase, formatCityStateZip, encodeMapURI } from '@edge/spark/utils'
import { MUIRouterLink } from '@edge/spark/ui'

const Address = styled(Typography)(({ theme }) => ({
    textAlign: 'left',
    fontSize: '12px',
    color: 'black',
    [theme.breakpoints.down('sm')]: {
        fontWeight: 500,
    },
}))

interface LocationType {
    address1?: string | null
    address2?: string | null
    city?: string | null
    state?: string | null
    type?: string | null
    zip?: string | null
}

interface Props {
    location: LocationType
}

export const CompanyLocationItem: React.FC<Props> = ({ location }: Props) => {
    const { address1, address2, type } = location
    const mapLink = encodeMapURI(location)

    return (
        <Stack direction="row" alignItems="flex-start" sx={{ mb: 1 }}>
            <Stack sx={{ width: 'auto' }}>
                <LocationOnIcon sx={{ color: grey[600] }} fontSize="small" />
            </Stack>
            <Stack sx={{ width: '100%', ml: '12px' }} direction="column">
                <Typography
                    color="textSecondary"
                    sx={{ textAlign: 'left', fontSize: '14px', paddingBottom: '3px', color: 'grey' }}
                >
                    {formatTitleCase(type)}
                </Typography>
                <Stack>
                    <Address>{formatTitleCase(address1)}</Address>
                    {address2 && <Address>{address2}</Address>}
                    <Address variant="body1">{formatCityStateZip(location)}</Address>
                </Stack>
                {mapLink && type && type.toLowerCase() !== 'mailing' && (
                    <Stack direction="row" alignItems="center">
                        <MUIRouterLink href={mapLink} target="_blank" sx={{ display: 'flex', alignItems: 'center' }}>
                            <DirectionsIcon color="primary" fontSize="small" sx={{ m: '5px' }} />
                            <Typography variant="body2" color="primary" className="directions">
                                Get Directions
                            </Typography>
                        </MUIRouterLink>
                    </Stack>
                )}
            </Stack>
        </Stack>
    )
}
